import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getAll = async (params = {}) => {

  const query = `
    query AllSignosVitales(
      $tokenCita: String
    ) {
      allSignosVitales(
        tokenCita: $tokenCita
      ) {
        total
        status
        message
        signosVitales {
          id
          token
          cita {
            token
          }
          peso
          temperatura
          tensionArterialDiastolica
          tensionArterialSistolica
          imc
          pulso
          freqRespiratoria
          satOxigeno
          perimetroCefalico
          talla
          perimetroAbdominal
          usuarioCreador {
            id
            username
          }
          fechaCreacion
        }
      }
    }
  `;

  const variables = {
    ...params
  }

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;

    const response2 = response.data.data.allSignosVitales;
    if(response2.status !== 'success') return null;
    
    const data = response2;
    return data;
    
  }catch(error){
    console.log('Error al obtener signos vitales', error);
    return null
  }
}



const getByToken = async ( token ) => {

  const query = `
    query qrgetTokenSignosvital($token: String!){
      getTokenSignosvital(tokenSignosvital: $token) {
        signosVital {
          id
          temperatura
          peso
          tensionArterialDiastolica
          tensionArterialSistolica
          imc
          pulso
          freqRespiratoria
          satOxigeno
          perimetroCefalico
          talla
          perimetroAbdominal
          estadoSignosvital
          cita{
            fechaCita
            horaCita
            doctor{
              especialidad{
                descripcion
              }
              idPersona{
                primerNombre
                primerApellido
              }
            }
            paciente{
              persona{
                primerNombre
                primerApellido
                identificacion
                fechaNacimiento
              }
            }
          }
        }
        status
        message
      }
    }
  `;
  const variables = {
    token
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    if (response.status === 200 && response.data.data.getTokenSignosvital.status === 'success') {
      const signosVitalData = response.data.data.getTokenSignosvital.signosVital;

      return signosVitalData;
    }
  } catch (error) {
    console.error("Error getSignosVitalesByToken:", error);
    return null;
  }
}




const getHistorialByPaciente = async ( idPaciente ) => {

  if(!idPaciente) {
    console.error("Error getHistorialByPaciente: idPaciente is null");
    return null;
  }

  const query = `
    query MyQuery($idPaciente: ID) {
      allCitas(pacienteId: $idPaciente) {
        status
        total
        message
        cita {
          id
          token
          fechaCita
          horaCita
          paciente {
            persona {
              fechaNacimiento
            }
          }
          signosvitalSet {
            id
            token
            imc
            freqRespiratoria
            perimetroAbdominal
            perimetroCefalico
            peso
            pulso
            satOxigeno
            talla
            temperatura
            tensionArterialDiastolica
            tensionArterialSistolica
          }
          
        }
      }
    }
  `;

  const variables = {
    idPaciente
  };

  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200 ) return null;

    const response2 = response.data.data.allCitas;
    if( response2.status !== 'success' ) return null;

    const data = {
      citas: response2.cita,
      total: response2.total
    };

    return data;

  } catch (error) {
    console.error("Error getHistorialByPaciente:", error);
    return null;
  }
}



const getByCita = async (tokenCita) => {

  const responseSignos = await getAll({ tokenCita });
  const dataSignos = responseSignos?.signosVitales[0];

  if(!dataSignos) return null;

  return dataSignos
}



const saveRegister = async (tokenCita, dataSignos) =>  {

  const query = `
    mutation saveRegister(
      $tokenCita        : String!,
      $idRegistroSignos : String,

      $peso             : Float!,
      $talla            : Float!,
      $imc              : Float!,
      $temperatura      : Float!,
      
      $pulso            : Float!,
      $freqRespiratoria : Float,
      $satOxigeno       : Float!,
      $perimetroCefalico: Float,
      $perimetroAbdominal: Float,
      $tensionArterialSistolica: Int!,
      $tensionArterialDiastolica: Int!,
    ) {
      saveRegister(
        tokenCita        : $tokenCita,
        idRegistroSignos : $idRegistroSignos,

        temperatura  : $temperatura,
        peso         : $peso,
        tensionArterialSistolica: $tensionArterialSistolica,
        tensionArterialDiastolica: $tensionArterialDiastolica,

        imc               : $imc,
        pulso             : $pulso,
        freqRespiratoria  : $freqRespiratoria,
        satOxigeno        : $satOxigeno,
        perimetroCefalico : $perimetroCefalico,
        talla             : $talla,
        perimetroAbdominal: $perimetroAbdominal,
      ) {
        signosVital {
          token
          id
        }
        status
        message
      }
    }
  `;

  const variables = {
    tokenCita                 : tokenCita,
    idRegistroSignos          : dataSignos.idRegistroSignos,
    
    temperatura               : dataSignos.temperatura,
    peso                      : dataSignos.peso,
    talla                     : dataSignos.talla,
    imc                       : dataSignos.imc,
    pulso                     : dataSignos.pulso,
    freqRespiratoria          : dataSignos.freqRespiratoria,
    satOxigeno                : dataSignos.satOxigeno,
    perimetroCefalico         : dataSignos.perimetroCefalico,
    perimetroAbdominal        : dataSignos.perimetroAbdominal,
    tensionArterialSistolica  : dataSignos.tensionArterialSistolica,
    tensionArterialDiastolica : dataSignos.tensionArterialDiastolica,
  };


  try {
    const response = await axios.post(rutas.axios + 'api', { query, variables });

    if (response.status !== 200) return null;

    const response2 = response.data.data.saveRegister;
    if (response2.status !== 'success') return null;
      
    const data = response2.signosVital;
    return data
    
  } catch (err) {
    console.log("Error al registrar signos vitales", err);
    return null;
  }
}

export const signosVitalesService = {
  getAll,
  getByToken,
  getHistorialByPaciente,
  getByCita,
  saveRegister
}